@if (showMicrophoneButton() || showCameraButton()) {
<div class="media-call-buttons">
  @if (showMicrophoneButton()) {
  <qai-call-button
    [label]="('call.AUDIO' | transloco)"
    [kind]="isMicOn() ? 'tertiary' : 'destructive'"
    [icon]="isMicOn() ? 'microphone' : 'microphone-off'"
    [disabled]="disableMicButton()"
    (clicked)="handleMicrophoneClick()"
  />
  } @if (showCameraButton()) {
  <qai-call-button
    [label]="('call.VIDEO_LABEL' | transloco)"
    [kind]="isVideoOn() && isCameraAvailable() ? 'tertiary' : 'destructive'"
    [icon]="isVideoOn() && isCameraAvailable() ? 'video-recorder' : 'video-recorder-off'"
    [errorBadge]="!isCameraAvailable()"
    [disabled]="disableVideoButton()"
    (clicked)="handleVideoClick()"
    [matTooltipDisabled]="isCameraAvailable()"
    matTooltipClass="cameraUnavailable"
    [matTooltip]="('call.BROWSER_ACCESS_DENIED' | transloco)"
  />
  }
</div>
}

<button
  class="endCallButton"
  [style.margin-inline-start]="(showMicrophoneButton() || showCameraButton()) ? 'var(--spacing-lg)' : null"
  qai-button
  size="large"
  kind="primary"
  [disabled]="disableConfirmActionButton() && !suppressConfirmAction()"
  (click)="handleOnConfirmActionClick()"
>
  {{confirmActionLabel() | transloco}}
</button>
